<div class="body-wrapper">
  <div class="middle-section">
    <div class="content-wrapper" id="content-wrapper" #c>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<app-alert></app-alert>
